export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob), a = document.createElement("a");
  a.href = url; a.download = filename || "documento";
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};

export const previewPdf = (blob, filename = "documento.pdf") => {
  const isPdf = blob?.type === "application/pdf" || /\.pdf$/i.test(filename);
  if (!isPdf) return downloadBlob(blob, filename);
  const pdf = blob.type === "application/pdf" ? blob : new Blob([blob], { type: "application/pdf" });
  window.dispatchEvent(new CustomEvent("pdf-preview", { detail: { blob: pdf, filename } }));
};
